<template>
    <div>
        <b-row v-if="permissions.includes('warehouse-shipping-inquiry')">
            <!-- card collapsible  -->
            <b-col md="12">
                <b-card-actions
                title="Filter"
                :collapsed="true"
                action-collapse
                >
                    <b-row>
                        <b-col cols="3">
                            <b-form-group
                            label="Code"
                            label-for="code"
                            >
                            <b-form-input
                                id="code"
                                placeholder="Code"
                                v-model="filter.code"
                                required
                            />
                            </b-form-group>
                        </b-col>
                        <b-col cols="3">
                            <b-form-group
                            label="Customer Name"
                            label-for="customer_name"
                            >
                            <b-form-input
                                id="customer_name"
                                placeholder="Customer Name"
                                v-model="filter.customer_name"
                                required
                            />
                            </b-form-group>
                        </b-col>
                        <b-col md="3">
                            <b-form-group
                            label="Start Date"
                            label-for="start_date"
                            >
                                <flat-pickr
                                id="start_date"
                                v-model="filter.start_date"
                                class="form-control"
                                :config="{ dateFormat: 'Y-m-d'}"
                                placeholder="Start Date"
                                />
                                <!-- <p>Value: '{{ filter.start_date }}'</p> -->
                            </b-form-group>
                        </b-col>
                        <b-col md="3">
                            <b-form-group
                            label="End Date"
                            label-for="end_date"
                            >
                                <flat-pickr
                                id="end_date"
                                v-model="filter.end_date"
                                class="form-control"
                                :config="{ dateFormat: 'Y-m-d'}"
                                placeholder="End Date"
                                />
                                <!-- <p>Value: '{{ filter.end_date }}'</p> -->
                            </b-form-group>
                        </b-col>
                        <b-col md="3">
                            <b-form-group
                            label="Status"
                            label-for="status"
                            >
                                <b-form-select
                                id="status"
                                v-model="filter.selectedStatus"
                                :options="filter.optionsStatus"
                                />
                                <!-- Selected: <strong>{{ filter.selectedStatus }}</strong> -->
                            </b-form-group>
                        </b-col>
                        <b-col md="12">
                            <b-button
                            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                            variant="outline-primary"
                            class="mt-1"
                            @click="getInquiry(1, filter.code, filter.customer_name, filter.start_date, filter.end_date, filter.selectedStatus)"
                            >
                            Search
                            </b-button>
                        </b-col>
                    </b-row>
                </b-card-actions>
            </b-col>
        </b-row>
        <b-row v-if="permissions.includes('warehouse-shipping-inquiry')">
            <b-col md="12">
                <b-card>
                    <!-- search input -->
                    <!-- <b-row>
                        <b-col class="custom-search d-flex justify-content-end">
                            <b-form-group>
                                <div class="d-flex align-items-center">
                                    <label class="mr-1">Search</label>
                                    <b-form-input
                                        v-model="searchTerm"
                                        placeholder="Search"
                                        type="text"
                                        class="d-inline-block"
                                    />
                                </div>
                            </b-form-group>
                        </b-col>
                    </b-row> -->

                    <!-- table -->
                    <vue-good-table
                    :columns="columns"
                    :rows="rows"
                    :rtl="direction"
                    :search-options="{
                        enabled: true,
                        externalQuery: searchTerm 
                    }"
                    :select-options="{
                        enabled: false,
                        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                        selectionInfoClass: 'custom-class',
                        selectionText: 'rows selected',
                        clearSelectionText: 'clear',
                        disableSelectInfo: true, // disable the select info panel on top
                        selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
                    }"
                    :pagination-options="{
                        enabled: true,
                        perPage:pageLength
                    }"
                    >
                        <template
                            slot="table-row"
                            slot-scope="props"
                        >

                            <!-- Column: Name -->
                            <span
                            v-if="props.column.field === 'name'"
                            class="text-nowrap"
                            >
                                <span class="text-nowrap">{{ props.row.name }}</span>
                            </span>

                            <!-- Column: Code -->
                            <span
                            v-else-if="props.column.field === 'code'"
                            class="text-nowrap"
                            >
                                <span class="text-nowrap" v-if="props.row.code === ''">-</span>
                                <span class="text-nowrap" v-else>{{ props.row.code }}</span>
                            </span>

                            <!-- Column: Date -->
                            <span
                            v-else-if="props.column.field === 'created_at'"
                            class="text-nowrap"
                            >
                                <span class="text-nowrap">{{ moment(props.row.created_at) }}</span>
                            </span>

                            <!-- Column: Status -->
                            <span
                            v-else-if="props.column.field === 'status'"
                            class="text-nowrap"
                            >
                                <b-badge :variant="statusVariant(props.row.status)">
                                    <span class="text-nowrap" v-if="props.row.status === 1">{{ props.row.status_name }}</span>
                                    <span class="text-nowrap" v-else-if="props.row.status === 2">{{ props.row.status_name }}</span>
                                    <span class="text-nowrap" v-else-if="props.row.status === 3">{{ props.row.status_name }}</span>
                                    <span class="text-nowrap" v-else-if="props.row.status === 4">{{ props.row.status_name }}</span>
                                    <span class="text-nowrap" v-else-if="props.row.status === 5">{{ props.row.status_name }}</span>
                                </b-badge>
                            </span>

                            <!-- Column: Action -->
                            <span v-else-if="props.column.field === 'action'">
                                <span>
                                    <b-dropdown
                                    variant="link"
                                    toggle-class="text-decoration-none"
                                    no-caret
                                    >
                                        <template v-slot:button-content>
                                            <feather-icon
                                            icon="MoreVerticalIcon"
                                            size="16"
                                            class="text-body align-middle mr-25"
                                            />
                                        </template>
                                        <b-dropdown-item v-bind:to="{path: '/warehouse/shipping/' +props.row.id}" v-if="permissions.includes('warehouse-shipping-detail')">
                                            <feather-icon
                                            icon="Edit2Icon"
                                            class="mr-50"
                                            />
                                            <span>Detail</span>
                                        </b-dropdown-item>
                                        <b-dropdown-item v-b-modal.modal-assign @click="trigger(props.row.id)" v-if="permissions.includes('warehouse-shipping-assign')">
                                            <feather-icon
                                            icon="SendIcon"
                                            class="mr-50"
                                            />
                                            <span>Assign</span>
                                        </b-dropdown-item>
                                    </b-dropdown>
                                </span>
                            </span>

                            <!-- Column: Common -->
                            <span v-else>
                            {{ props.formattedRow[props.column.field] }}
                            </span>
                        </template>

                        <!-- pagination -->
                        <template
                            slot="pagination-bottom"
                        >
                            <div class="d-flex justify-content-between flex-wrap">
                                <div class="d-flex align-items-center mb-0 mt-1">
                                    <span class="text-nowrap ">
                                    Showing {{ meta.from }} to {{ meta.to }}
                                    </span>
                                    <span class="text-nowrap">&nbsp;of {{ meta.total }} entries </span>
                                </div>
                                <div>
                                    <b-pagination
                                    :value="1"
                                    :total-rows="meta.total"
                                    :per-page="meta.per_page"
                                    first-number
                                    last-number
                                    align="right"
                                    prev-class="prev-item"
                                    next-class="next-item"
                                    class="mt-1 mb-0"
                                    @input="(value)=>getInquiry(value, filter.code, filter.customer_name, filter.start_date, filter.end_date, filter.selectedStatus)"
                                    >
                                    <template #prev-text>
                                        <feather-icon
                                        icon="ChevronLeftIcon"
                                        size="18"
                                        />
                                    </template>
                                    <template #next-text>
                                        <feather-icon
                                        icon="ChevronRightIcon"
                                        size="18"
                                        />
                                    </template>
                                    </b-pagination>
                                </div>
                            </div>
                        </template>
                    </vue-good-table>
                    <!-- modal Assign -->
                    <b-modal
                    id="modal-assign"
                    title="Assign Form"
                    ok-title="Assign"
                    cancel-variant="outline-secondary"
                    hide-footer
                    no-close-on-backdrop
                    >
                        <validation-observer ref="loginValidation">
                        <b-form ref="form" @submit.prevent>
                            <b-form-group
                            :state="errors"
                            label="Assign"
                            label-for="assign"
                            invalid-feedback="Assign required"
                            >
                                <validation-provider
                                #default="{ errors }"
                                name="assign"
                                rules="required"
                                >
                                    <v-select
                                    id="assign"
                                    name="assign"
                                    v-model="form.selectedEmployee"
                                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                    label="text"
                                    :options="form.optionsEmployee"
                                    :state="errors.length > 0 ? false:null"
                                    placeholder="Select Assign"
                                    required="required"
                                    />
                                    <small class="text-danger">{{ errors[0] || errMessage }}</small>
                                </validation-provider>
                            </b-form-group>

                            <b-row>
                                <b-col>
                                    <b-button
                                        class="mt-3"
                                        type="submit"
                                        variant="primary"
                                        block
                                        @click="assign()"
                                    >
                                        Process
                                    </b-button>
                                </b-col>
                            </b-row>
                        </b-form>
                        </validation-observer>
                    </b-modal>
                    <!-- end modal assign -->
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import {
    BForm, BFormFile, BModal, BButton, BRow, BCol, BCard, BAvatar, BBadge, BPagination, BFormGroup, BFormInput, BFormSelect, BDropdown, BDropdownItem,
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import store from '@/store/index'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import BCardActions from '@core/components/b-card-actions/BCardActions.vue'
import moment from 'moment'
import flatPickr from 'vue-flatpickr-component'
import vSelect from 'vue-select'

export default {
    components: {
        flatPickr,
        BCardActions,
        VueGoodTable,
        ToastificationContent,
        vSelect,
        ValidationProvider,
        ValidationObserver,
        BForm,
        BFormFile,
        BModal,
        BButton,
        BRow,
        BCol,
        BCard, 
        BAvatar,
        BBadge,
        BPagination,
        BFormGroup,
        BFormInput,
        BFormSelect,
        BDropdown,
        BDropdownItem,
    },
    directives: {
        Ripple,
    },
    data() {
        return {
            pageLength: 10,
            dir: false,
            columns: [
                {
                    label: 'Code',
                    field: 'code',
                },
                {
                    label: 'Order Code',
                    field: 'order.code',
                },
                {
                    label: 'Customer Name',
                    field: 'customer.name',
                },
                {
                    label: 'Date',
                    field: 'created_at',
                },
                {
                    label: 'Status',
                    field: 'status',
                },
                {
                    label: 'Action',
                    field: 'action',
                    width: '100px'
                },
            ],
            form: {
                selectedEmployee: null,
                optionsEmployee: [],
                employeeValue: null
            },
            employee_id: null,
            filter: {
                code: '',
                customer_name: '',
                start_date: '',
                end_date: '',
                selectedStatus: '',
                optionsStatus: [
                    {value: '', text: 'All'},
                    {value: 1, text: 'Waiting assignment'},
                    {value: 2, text: 'Head warehouse assign courier'},
                    {value: 3, text: 'Courier accept delivery order'},
                    {value: 4, text: 'Courier reject delivery order'},
                    {value: 5, text: 'Courier finish delivery order'}
                ],
            },
            meta: {
                current_page: 1,
                last_page: 0,
                from: 0,
                to: 0,
                per_page: 10,
                total: 0,
            },
            permissions: [],
            assign_id: null,
            search: '',
            rows: [],
            searchTerm: '',
            errMessage: '',
            errors: '',
            file: null
        }
    },
    computed: {
        statusVariant() {
            const statusColor = {
                1 : 'light-warning',
                2 : 'light-info',
                3 : 'light-primary',
                4 : 'light-danger',
                5 : 'light-success'
            }

            return status => statusColor[status]
        },
        direction() {
            if (store.state.appConfig.isRTL) {
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.dir = true
                return this.dir
            }
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.dir = false
            return this.dir
        },
    },
    watch: {
        'form.selectedEmployee': function(data) {
            this.form.employeeValue = data.value
        },
    },
    created() {
        this.getAllPermissions()
        this.getEmployeeID()
        this.getInquiry(1, '', '', '', '', '')
    },
    methods: {
        moment(date) {
            return moment(date).format('DD-MM-YYYY, hh:mm');
        },
        getAllPermissions() {
            this.permissions = sessionStorage.getItem('permissions')
        },
        getEmployeeID() {
            this.employee_id = sessionStorage.getItem('employeeID')
            this.getEmployees()
        },
        getEmployees() {
            this.$http.get('employees?manager_id='+this.employee_id)
            .then(response => { 
                // console.log(response.data.data)
                var datas = response.data.data
                var i
                for(i=0; i<datas.length; i++) {
                    var $data = {
                        value: datas[i].id,
                        text: datas[i].name
                    }
                    // console.log($data)
                    this.form.optionsEmployee.push($data)
                }
            });
        },
        getInquiry($page, $code, $customer, $start_date, $end_date, $status) {
            this.$http.get('warehouse/shippings?page=' + $page + ($code ? "&code="+this.filter.code : '') + ($customer ? "&customer="+this.filter.customer_name : '') + ($start_date ? "&start_date="+this.filter.start_date : '') + ($end_date ? "&end_date="+this.filter.end_date : '') + ($status ? "&status="+this.filter.selectedStatus : ''))
            .then(res => { 
                this.rows = res.data.data
                // console.log(res.data.data)
                var meta = res.data.meta
                if (meta.from != null) {
                    this.meta.from = meta.from
                }
                if (meta.to != null) {
                    this.meta.to = meta.to
                }
                this.meta.current_page = meta.current_page
                this.meta.last_page = meta.last_page
                this.meta.per_page = meta.per_page
                this.meta.total = meta.total
            })
        },
        trigger($id) {
            this.assign_id = $id
        },
        assign() {
            this.$http
            .post("warehouse/shipping/"+this.assign_id+"/assign", {
                "user_id": this.form.employeeValue,
            })
            .then((response) => {
                this.$toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Notification',
                        icon: 'BellIcon',
                        text: 'Success Assign',
                        variant: 'success',
                    },
                })
                location.href = "/warehouse/shipping"
                // console.log(response.data.data)
            }).catch((errors) => {
                this.errMessage = errors.response.data.message
                this.$toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Notification',
                        icon: 'BellIcon',
                        text: this.errMessage,
                        variant: 'warning',
                    },
                })
                console.log(errors.response)
            });
        },
    },
}
</script>

<style lang="scss" >
@import "@core/scss/vue/libs/vue-good-table.scss";
@import '@core/scss/vue/libs/vue-flatpicker.scss';
@import '@core/scss/vue/libs/vue-select.scss';
</style>